import React from 'react';
import { TableRow } from '@mui/material';
import { TSCell, TSTable } from '../ui/TableStructure';

const ScoringStructureTable = ({ scoringStructure }) => {
	const sstrucRows = scoringStructure.structure.map((s) => <TableRow key={s.position}>
		<TSCell>{s.position || "No Show"}</TSCell>
		<TSCell>{s.score}</TSCell>
	</TableRow>
	);

	return(
		<TSTable title={"Points Per Game"} headings={["Position","Points"]}>
			{sstrucRows}
		</TSTable>
	);
};

export default ScoringStructureTable;